module.exports = __webpack_public_path__ + "img/logo_ecshopx.92521014.png";